module.exports = __webpack_public_path__ + "img/rules-02.0f2cd67a.svg";